import { Helmet } from 'react-helmet-async';
import { useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  Card,
  Stack,
  Button,
  Box,
  Checkbox,
  MenuItem,
  Typography,
  TextField,
  Modal,
  FormControl,
  Select,
  OutlinedInput,
  Divider,
  Tooltip,
  IconButton,
  useMediaQuery,
  FormControlLabel,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'moment/locale/tr';

import Iconify from 'src/components/iconify';
import api from 'src/services/BaseService';
import { tokenService } from 'src/services';
import CreateWorkOrderModal from 'src/components/modals/CreateWorkOrderModal';
import DeliveryModal from 'src/components/modals/DeliveryModal';
import AddEditPersonelModal from 'src/components/modals/AddEditPersonelModal';
import './muhaberatOutput.css';
import AddEntityButton from 'src/components/shared/AddEntityButton';
import EditButton from 'src/components/shared/EditButton';
import ClearButton from 'src/components/shared/ClearButton';
import FilterButton from 'src/components/shared/FilterButton';
import ExportToExcelButton from 'src/components/shared/ExportToExcelButton';
import DynamicTable from 'src/components/shared/DynamicTable';
import CustomFilter from 'src/components/filter/CustomFilter';
import FilterViewButton from 'src/components/shared/FilterViewButton';
import EditMuhaberatOutputPost from 'src/components/modals/EditMuhaberatOutputPost';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import logoFormSrc from 'src/assets/images/logo-form.png';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const directions = [
  { value: 'all', label: 'Tümü' },
  { value: 'MallLogisticsToCustomer', label: 'Muhaberattan Müşteriye' },
  { value: 'CustomerToMallLogistics', label: 'Müşteriden Muhaberata' },
];

const emailsMap = {
  OF0: 'zc.ofisavm@zorlu.com',
  T2: ['zc.te2lobi@zorlu.com', 'zc.sete3lobi@zorlu.com'],
  T1: 'zc.te1lobi@zorlu.com',
  R1: 'zc.r1lobi@zorlu.com',
  R2: 'zc.r2lobi@zorlu.com',
  R3: 'zc.r3lobi@zorlu.com',
};

moment.locale('tr');

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 0;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const StatusList = [
  { label: 'Tümü', id: 0 },
  { label: 'Porter Emrinde', id: 8 },
  { label: 'Porter Zimmetinde', id: 4 },
  { label: 'Şubede', id: 5 },
  { label: 'Teslim Edildi', id: 1 },
];

const getEffectiveStatuses = (selectedCargoStatus) => {
  if (!selectedCargoStatus || selectedCargoStatus.length === 0)
    return [1, 4, 5, 8];

  const ids = selectedCargoStatus.map((x) => Number(x.id));

  if (ids.includes(0)) return [1, 4, 5, 8];

  const cleaned = ids.filter((x) => x === 1 || x === 4 || x === 5 || x === 8);
  return cleaned.length > 0 ? Array.from(new Set(cleaned)) : [1, 4, 5, 8];
};

export default function MuhaberatOutput() {
  const parsedUser = JSON.parse(localStorage.getItem('user'));
  const customer = useSelector((state) => state.customerReducer);

  const isMountedRef = useRef(true);
  const requestIdRef = useRef(0);
  const firstInputRef = useRef(null);

  const [isBackdropOpen, setIsBackdropOpen] = useState(false);
  const [dataLimit, setDataLimit] = useState(2000);
  const [page, setPage] = useState(0);
  const [resetPage, setResetPage] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [selectedDirection, setSelectedDirection] = useState({
    value: 'all',
    label: 'Tümü',
  });

  const [filterName, setFilterName] = useState('');
  const [customerNameLike, setCustomerNameLike] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [originalData, setOriginalData] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedCargoStatus, setSelectedCargoStatus] = useState([]);
  const [locations, setLocations] = useState([]);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [firm, setFirm] = useState('');
  const [barcode, setBarcode] = useState('');
  const [cargo, setCargo] = useState('');
  const [tower, setTower] = useState('');
  const [office, setOffice] = useState('');

  const [handoverModal, setHandoverModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState('');
  const [addPersonelModalOpen, setAddPersonelModalOpen] = useState(false);
  const [showAddPersonelModal, setShowAddPersonelModal] = useState(false);
  const [personelList, setPersonelList] = useState([]);

  const [confirmCode, setConfirmCode] = useState(null);
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [recieverNameLastname, setRecieverNameLastname] = useState('');
  const [open, setOpen] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showPopUpError, setShowPopUpError] = useState(false);

  const [branchTitles, setBranchTitles] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  const [deliveredName, setDeliveredName] = useState('');
  const [totalPackageCount, setTotalPackageCount] = useState(0);

  const [selectedPost, setSelectedPost] = useState();
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [deliveryTimestamp, setDeliveryTimestamp] = useState(null);

  const [malls, setMalls] = useState([]);
  const [selectedMall, setSelectedMall] = useState(null);
  const [muhaberatStaticQR, setMuhaberatStaticQR] = useState('');
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [hasMuhaberatOffice, setHasMuhaberatOffice] = useState(true);
  const [isMallLoading, setIsMallLoading] = useState(false);
  const [porterTransactionIDs, setPorterTransactionIDs] = useState([]);

  const [filterModal, setFilterModal] = useState(false);
  const isMobile = useMediaQuery('(max-width:768px)');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleModal = () => setFilterModal(true);
  const handleCloseModal = () => setFilterModal(false);

  const handleChangeCustomerNameLike = (event) => {
    setCustomerNameLike(event.target.checked);
  };

  const TABLE_HEAD = useMemo(
    () => [
      {
        id: parsedUser.type === 'user' ? 'none' : 'checkbox',
        label: '',
        alignRight: false,
        format: (value, row) => {
          const statusNum = Number(row.status);
          if (statusNum === 5 && parsedUser.type !== 'user') {
            return (
              <Checkbox
                checked={selected.indexOf(row.id) !== -1}
                onChange={(e) => handleCheckboxChange(e, row.id, row)}
              />
            );
          }
          return null;
        },
        sx: { width: 50 },
      },
      { id: 'no', label: 'No', alignRight: false, sx: { width: 10 } },
      { id: 'barcode', label: 'Barkod', alignRight: false },
      {
        id: 'title',
        label: 'Kişi',
        alignRight: false,
        sortBy: 'dataJSON.customerName',
        format: (value, row) => row.dataJSON?.customerName,
      },
      { id: 'branchTitle', label: 'Firma', alignRight: false },
      {
        id: 'tower',
        label: 'Kule',
        alignRight: false,
        format: (value, row) => row.dataJSON?.tower,
        sortBy: 'dataJSON.tower',
      },
      {
        id: 'office',
        label: 'Daire',
        alignRight: false,
        format: (value, row) => row.dataJSON?.office,
        sortBy: 'dataJSON.office',
      },
      {
        id: 'corporationID',
        label: 'Firma ID',
        alignRight: false,
        format: (value, row) => row.customer?.corporationID,
        sortBy: 'customer.corporationID',
      },
      {
        id: 'status',
        label: 'Kargo Durumu',
        alignRight: false,
        format: (value, row) => {
          const statusNum = Number(row.status);

          if (statusNum === 8) {
            return (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'left',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    backgroundColor: 'rgba(156, 39, 176, 0.16)',
                    padding: '7px',
                    borderRadius: '5px',
                  }}
                >
                  Porter Emrinde
                </span>
              </div>
            );
          }

          if (statusNum === 4) {
            return (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'left',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    backgroundColor: 'rgba(0, 44, 101, 0.16)',
                    padding: '7px',
                    borderRadius: '5px',
                  }}
                >
                  Porter Zimmetinde
                </span>
              </div>
            );
          }

          if (statusNum === 5) {
            return (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'left',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    backgroundColor: 'rgba(247, 169, 55, 0.36)',
                    padding: '7px',
                    borderRadius: '5px',
                  }}
                >
                  Şubede
                </span>
              </div>
            );
          }

          if (statusNum === 1) {
            return (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'left',
                  alignItems: 'center',
                }}
              >
                <span
                  style={{
                    backgroundColor: 'rgba(10, 127, 50, 0.24)',
                    padding: '7px',
                    borderRadius: '5px',
                  }}
                >
                  Teslim Edildi
                </span>
              </div>
            );
          }

          return '-';
        },
      },
      {
        id: 'orderInventory',
        label: 'Paket Sayısı',
        alignRight: false,
        format: (value) => value,
        sortFunction: (row) => parseInt(row.orderInventory, 10),
      },
      {
        id: 'takenBy',
        label: 'Teslim Alan Kişi',
        alignRight: false,
        format: (value, row) => {
          const statusNum = Number(row.status);
          if (row.handover && statusNum === 1) {
            return row.handover?.name + ' ' + row.handover?.lastname;
          }
          return '-';
        },
        sortBy: 'handover.name',
      },
      {
        id: 'createdDateTime',
        label: 'Oluşturulma Tarihi',
        alignRight: false,
        format: (value) => moment.unix(value).format('DD/MM/YYYY HH:mm'),
      },
      {
        id: 'deliveredDateTime',
        label: 'Teslim Tarihi',
        alignRight: false,
        format: (value) =>
          value ? moment.unix(value).format('DD/MM/YYYY HH:mm') : '-',
      },
      {
        id: 'shipmentFirm',
        label: 'Kargo Firması',
        sortBy: 'dataJSON.shipmentFirm',
        alignRight: false,
        format: (value, row) => row.shipmentFirm,
      },
      {
        id: 'operation',
        label: '',
        alignRight: false,
        format: (value, row) => {
          const createdTime = new Date(row.createdDateTime * 1000);
          const currentTime = new Date();
          const timeDifference = currentTime - createdTime;
          const oneDayInMilliseconds = 24 * 60 * 60 * 1000;

          const statusNum = Number(row.status);

          if (statusNum === 8 && parsedUser.type !== 'user') {
            return (
              <div
                style={{ gap: '10px', flexDirection: 'row', display: 'flex' }}
              >
                <EditButton
                  tooltip="QR Göster"
                  icon={'mdi:qrcode'}
                  onClick={() => setQrModalOpen(true)}
                />

                {timeDifference < oneDayInMilliseconds && (
                  <EditButton onClick={() => handleOpenEditModal(row)} />
                )}
              </div>
            );
          }

          if (statusNum === 5 && parsedUser.type !== 'user') {
            return (
              <div
                style={{ gap: '10px', flexDirection: 'row', display: 'flex' }}
              >
                <EditButton
                  tooltip="İşlem"
                  icon={'iconoir:delivery'}
                  onClick={() => handleOpenDeliveryModal(row.id, row)}
                />

                {timeDifference < oneDayInMilliseconds && (
                  <EditButton onClick={() => handleOpenEditModal(row)} />
                )}
              </div>
            );
          }

          return null;
        },
        sx: { width: 100 },
      },
    ],
    [parsedUser.type, selected]
  );

  const canProceedWithPorter = useMemo(() => {
    if (!selectedItems || selectedItems.length === 0) return false;

    return selectedItems.every(
      (item) => item?.dataJSON?.direction === 'MallLogisticsToCustomer'
    );
  }, [selectedItems]);

  const handleOpenEditModal = (post) => {
    setSelectedPost(post);
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedPost(undefined);
    getData();
  };

  useEffect(() => {
    const handleOnlineStatus = () => setIsOnline(navigator.onLine);
    window.addEventListener('online', handleOnlineStatus);
    window.addEventListener('offline', handleOnlineStatus);

    return () => {
      window.removeEventListener('online', handleOnlineStatus);
      window.removeEventListener('offline', handleOnlineStatus);
    };
  }, []);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    const mallID = localStorage.getItem('mallID');
    setShowAddPersonelModal(mallID === '61973122632916808660');
  }, [customer]);

  useEffect(() => {
    setIsMallLoading(true);

    api
      .post('/malls/get-malls', {
        withOffices: true,
      })
      .then((response) => {
        if (!isMountedRef.current) return;

        if (response.data.status) {
          const mallList = response.data.result || [];
          setMalls(mallList);

          const mallID = localStorage.getItem('mallID');
          const matchedMall = mallList.find(
            (item) => String(item.id) === String(mallID)
          );

          setSelectedMall(matchedMall || null);
          const offices = matchedMall?.offices || [];
          const matchedMuhaberatOffice = offices.find(
            (officeItem) => String(officeItem?.isMuhaberat) === '1'
          );

          if (matchedMuhaberatOffice?.staticQR) {
            setMuhaberatStaticQR(matchedMuhaberatOffice.staticQR);
            setHasMuhaberatOffice(true);
          } else {
            setMuhaberatStaticQR('');
            setHasMuhaberatOffice(false);
          }
        } else {
          setMalls([]);
          setSelectedMall(null);
          setMuhaberatStaticQR('');
          setHasMuhaberatOffice(false);
        }
      })
      .catch((error) => {
        if (!isMountedRef.current) return;
        toast.error(error.message);
        setMalls([]);
        setSelectedMall(null);
        setMuhaberatStaticQR('');
        setHasMuhaberatOffice(false);
      })
      .finally(() => {
        if (!isMountedRef.current) return;
        setIsMallLoading(false);
      });
  }, []);

  useEffect(() => {
    const handleCopy = (event) => {
      const selectedText = window.getSelection().toString();
      const trimmedText = selectedText.trim();
      event.clipboardData.setData('text/plain', trimmedText);
      event.preventDefault();
    };

    document.addEventListener('copy', handleCopy);
    return () => {
      document.removeEventListener('copy', handleCopy);
    };
  }, []);

  useEffect(() => {
    if (filterModal) {
      setTimeout(() => {
        firstInputRef.current?.focus();
      }, 100);
    }
  }, [filterModal]);

  const getFilteredOrderList = useCallback(() => {
    const isFiltered =
      barcode ||
      cargo ||
      selectedCargoStatus.length > 0 ||
      selectedBranches.length > 0 ||
      startDate ||
      endDate ||
      firm ||
      office ||
      tower ||
      filterName ||
      deliveredName;

    const reqId = ++requestIdRef.current;

    const filters = {
      type: ['post-office', 'personal-post'],
      direction: ['CustomerToMallLogistics', 'MallLogisticsToCustomer'],
      mallID: customer?.customer?.id,
      status: getEffectiveStatuses(selectedCargoStatus),
      barcode: barcode || null,
      shipmentFirm: cargo || null,
      limit: isFiltered ? 1000000 : 2000,
      branchID: selectedBranches,
      tower: tower || null,
      office: office || null,
      startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
      endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
      customerName: filterName || null,
      handoverName: deliveredName || null,
      customerNameLike,
    };

    api
      .post('posts/get', filters)
      .then((response) => {
        if (!isMountedRef.current) return;
        if (reqId !== requestIdRef.current) return;

        if (response.data.status) {
          setOrderList(response.data.result || []);
          setResetPage(true);
        } else {
          toast.error('Filtreleme sonucu bulunamadı.');
          setOrderList([]);
        }
      })
      .catch(() => {
        if (!isMountedRef.current) return;
        toast.error('Filtreleme sırasında bir hata oluştu.');
        setOrderList([]);
      });
  }, [
    barcode,
    cargo,
    selectedCargoStatus,
    selectedBranches,
    startDate,
    endDate,
    firm,
    office,
    tower,
    filterName,
    deliveredName,
    customerNameLike,
    customer?.customer?.id,
  ]);

  const clearFilters = () => {
    setOrderList(originalData);
    setBarcode('');
    setFirm('');
    setCargo('');
    setTower('');
    setOffice('');
    setSelectedCargoStatus([]);
    setSelectedDirection({ value: 'all', label: 'Tümü' });
    setStartDate(null);
    setEndDate(null);
    setFilterName('');
    setDeliveredName('');
    setSelectedBranches([]);
    setResetPage(false);
  };

  const sendMail = (items, pdfLink, excelLink, emailTo) => {
    if (!emailTo || !deliveryTimestamp) return;

    const formattedDate = deliveryTimestamp.format('D MMMM YYYY HH:mm');
    const inventoryCount = items
      .reduce((sum, item) => sum + parseInt(item.orderInventory, 10), 0)
      .toString();

    api
      .post('flow/send-muhaberat-notification-mail', {
        email: emailTo,
        date: formattedDate,
        inventoryCount,
        pdfLink,
        excelLink,
      })
      .then(() => {})
      .catch((err) => {
        console.error('Mail gönderme hatası:', err);
      });
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedCargoStatus(
      typeof value === 'string' ? value.split(',') : value
    );
  };

  const handleChangeFilterBranch = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedBranches(value);
  };

  const handleCheckboxChange = (event, id, object) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [...selected];
    let newSelectedItems = [...selectedItems];

    if (selectedIndex === -1) {
      newSelected.push(id);
      newSelectedItems.push(object);
    } else {
      newSelected.splice(selectedIndex, 1);
      const itemIndex = newSelectedItems.findIndex((item) => item.id === id);
      newSelectedItems.splice(itemIndex, 1);
    }

    setSelected(newSelected);
    setSelectedItems(newSelectedItems);
  };

  const selectAll = () => {
    const selectedItemsLocal = orderList
      .filter((row) => Number(row.status) === 5)
      .map((row) => row);

    const selectedIdsLocal = orderList
      .filter((row) => Number(row.status) === 5)
      .map((row) => row.id);

    setSelectedItems(selectedItemsLocal);
    setSelected(selectedIdsLocal);
  };

  function exportToExcel(list, data = orderList, returnLink = false) {
    const temp1 = list?.map((x, index) => {
      const matchedData = data?.find((item) => item.id === x.id);
      const statusNum = Number(matchedData?.status ?? x.status);

      let a = {
        id: index + 1,
        customer: x.dataJSON.customerName || '',
        barcode: x.barcode || '',
        tower: x.dataJSON.tower || '',
        office: x.dataJSON.office || '',
        willTakenBy: recieverNameLastname || '',
        lobbyDelivery: '',
        amount: x.orderInventory || '',
        shipmentFirm: x.dataJSON.shipmentFirm || '',
        takenBy: returnLink
          ? recieverNameLastname
          : statusNum !== 5
          ? x.handover?.name + ' ' + x.handover?.lastname
          : '-',
        deliveredDate: returnLink
          ? deliveryTimestamp?.format('DD.MM.YYYY')
          : x.deliveredDateTime
          ? moment.unix(x.deliveredDateTime).format('DD/MM/YYYY')
          : '-',
        deliveredTime: returnLink
          ? deliveryTimestamp?.format('HH:mm')
          : x.deliveredDateTime
          ? moment.unix(x.deliveredDateTime).format('HH:mm')
          : '-',
        status: returnLink
          ? 'Teslim Edildi'
          : statusNum === 5
          ? 'Şubede'
          : 'Teslim Edildi',
      };

      if (matchedData) {
        a.customer = matchedData.customerName || a.customer;
        a.barcode = matchedData.barcode || a.barcode;
        a.amount = matchedData.orderInventory || a.amount;
        a.shipmentFirm = matchedData.shipmentFirm || a.shipmentFirm;
        a.tower = matchedData.tower || a.tower;
        a.office = matchedData.office || a.office;
        a.takenBy = matchedData.handover
          ? matchedData.handover.name + ' ' + matchedData.handover.lastname
          : a.takenBy;
        a.lobbyDelivery = matchedData.lobbyDelivery || a.lobbyDelivery;
        a.willTakenBy = matchedData.willTakenBy || a.willTakenBy;
        a.deliveredDate = matchedData.deliveredDateTime
          ? moment.unix(matchedData.deliveredDateTime).format('DD/MM/YYYY')
          : a.deliveredDate;
        a.deliveredTime = matchedData.deliveredDateTime
          ? moment.unix(matchedData.deliveredDateTime).format('HH:mm')
          : a.deliveredTime;

        const st = Number(matchedData.status);
        a.status = returnLink
          ? 'Teslim Edildi'
          : st === 5
          ? 'Şubede'
          : 'Teslim Edildi';
      }

      return a;
    });

    const payload = {
      type: 'excel',
      content: temp1,
      header: {
        NO: 'number',
        'İSİM SOYİSİM': 'string',
        BARKOD: 'string',
        KULE: 'string',
        DAİRE: 'string',
        'TESLİM ALAN': 'string',
        'LOBİ TESLİMATI': 'string',
        MİKTAR: 'string',
        'KARGO İSMİ': 'string',
        'TESLİM ALAN KİŞİ': 'string',
        'TESLİM TARİHİ': 'string',
        'TESLİM SAATİ': 'string',
        DURUM: 'string',
      },
      sheetTitle: 'İşler',
    };

    if (returnLink) {
      return api.post('excel/export', payload).then((response) => {
        if (response.data.status) return response.data.result;
        throw new Error('Excel export başarısız');
      });
    }

    api
      .post('excel/export', payload)
      .then((response) => {
        if (response.data.status) {
          try {
            const newWindow = window.open(response.data.result, '_blank');
            if (
              !newWindow ||
              newWindow.closed ||
              typeof newWindow.closed === 'undefined'
            ) {
              setShowPopUpError(true);
              throw new Error('Pop-up engellendi. Lütfen izin verin.');
            }
          } catch (e) {
            setShowPopUpError(true);
          }
        } else {
          toast.error("EXCEL'e aktarılırken bir hata meydana geldi.");
        }
      })
      .catch(() => {
        toast.error("EXCEL'e aktarılırken bir hata meydana geldi.");
      });
  }

  async function createPDF(selectedItemsList, returnLink = false) {
    // pdfmake'in browser'daki PNG decoder'ı (pngjs+zlib) sorunlu.
    // Canvas ile PNG→JPEG dönüştürüp pdfmake'e JPEG veriyoruz.
    const logoJpeg = await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/jpeg', 0.95));
      };
      img.onerror = () => reject(new Error('Logo yüklenemedi'));
      img.src = logoFormSrc;
    });

    const body = selectedItemsList.map((item, i) => [
      { text: i + 1, alignment: 'center' },
      { text: item.dataJSON.customerName || '-', alignment: 'left' },
      { text: item.barcode || '-', alignment: 'left' },
      {
        text: deliveryTimestamp?.format('DD.MM.YYYY HH:mm') || '-',
        alignment: 'center',
      },
      { text: recieverNameLastname || '-', alignment: 'left' },
      { text: item.orderInventory || '-', alignment: 'center' },
      { text: item.dataJSON.shipmentFirm || '-', alignment: 'left' },
    ]);

    const today = moment().format('DD.MM.YYYY');
    const [dayMonth, year] = today.split('.').reduce(
      (acc, part, idx) => {
        if (idx < 2) acc[0].push(part);
        else acc[1] = part;
        return acc;
      },
      [[], '']
    );
    const dayMonthText = dayMonth.join('.');
    const yearText = `.${year}`;

    const docDefinition = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      content: [
        {
          columns: [
            { image: logoJpeg, width: 80, margin: [0, 0, 0, 0] },
            {
              text: [{ text: dayMonthText, bold: true }, { text: yearText }],
              color: '#374151',
              alignment: 'right',
              margin: [0, 0, 0, 0],
            },
          ],
          columnGap: 0,
          margin: [0, 0, 0, 20],
        },
        {
          text: [
            {
              text: 'MALL LOGISTICS ',
              fontWeight: 300,
              fontSize: 14,
              bold: false,
              characterSpacing: 1.4,
              lineHeight: 1,
              alignment: 'center',
              color: '#000',
            },
            {
              text: 'ZORLU CENTER OFİS',
              fontWeight: 600,
              fontSize: 14,
              bold: true,
              characterSpacing: 3.6,
              lineHeight: 1.5,
              alignment: 'center',
              color: '#000',
            },
          ],
          margin: [0, 0, 0, 12],
        },
        {
          table: {
            headerRows: 1,
            widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: [
              [
                { text: 'NO', style: 'tableHeader' },
                { text: 'İSİM SOYİSİM', style: 'tableHeader' },
                { text: 'BARKOD NO', style: 'tableHeader' },
                { text: 'ZİMMET TARİHİ', style: 'tableHeader' },
                { text: 'ZİMMETE ALAN', style: 'tableHeader' },
                { text: 'MİKTAR', style: 'tableHeader' },
                { text: 'KARGO FİRMASI', style: 'tableHeader' },
              ],
              ...body,
            ],
          },
          layout: {
            fillColor: (rowIndex) => (rowIndex === 0 ? '#F5F5F5' : null),
            hLineColor: () => '#EEEEEE',
            vLineColor: () => '#EEEEEE',
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            paddingLeft: () => 6,
            paddingRight: () => 6,
            paddingTop: () => 4,
            paddingBottom: () => 4,
          },
        },
      ],
      styles: {
        tableHeader: {
          fontSize: 9,
          bold: false,
          color: '#6B7280',
          alignment: 'center',
        },
      },
      defaultStyle: {
        fontSize: 10,
      },
    };

    if (returnLink) {
      return new Promise((resolve, reject) => {
        pdfMake
          .createPdf(docDefinition, null, null, pdfFonts.pdfMake.vfs)
          .getBase64((data) => {
            api
              .post('flow/save-pdf', { content: data })
              .then((res) => {
                if (res.data.status) resolve(res.data.result);
                else reject(new Error('save-pdf failed'));
              })
              .catch(reject);
          });
      });
    } else {
      pdfMake.createPdf(docDefinition, null, null, pdfFonts.pdfMake.vfs).open();
    }
  }

  const getData = useCallback(() => {
    if (!customer?.customer?.id) return;

    const reqId = ++requestIdRef.current;

    api
      .post('flow/concierge-get-users', { metaTags: ['Zorlu Center'] })
      .then((response) => {
        if (!isMountedRef.current) return;
        if (reqId !== requestIdRef.current) return;

        if (response.data.status) setPersonelList(response.data.result || []);
        else setPersonelList([]);
      })
      .catch(() => {
        if (!isMountedRef.current) return;
        setPersonelList([]);
      });

    api
      .post('posts/get', {
        type: ['post-office', 'personal-post'],
        mallID: customer?.customer?.id,
        status: getEffectiveStatuses(selectedCargoStatus),
        limit: 2000,
        direction: ['CustomerToMallLogistics', 'MallLogisticsToCustomer'],
      })
      .then((response) => {
        if (!isMountedRef.current) return;
        if (reqId !== requestIdRef.current) return;

        if (response.data.status) {
          const data = response.data.result || [];
          const uniqueBranches = Array.from(
            new Map(
              data.map((item) => {
                const branchID =
                  item.dataJSON?.direction === 'CustomerToMallLogistics'
                    ? item.from?.branchID
                    : item.to?.branchID;
                return [item.branchTitle, branchID];
              })
            )
          ).map(([branchTitle, branchID]) => ({ branchTitle, branchID }));
          setBranchTitles(uniqueBranches);
          setOriginalData(data);
          setOrderList(data);
        } else {
          toast.error('Veri bulunamadı.');
          setOriginalData([]);
          setOrderList([]);
        }
      })
      .catch(() => {
        if (!isMountedRef.current) return;
        toast.error('Veriler çekilemedi, bağlantınızı kontrol ediniz.');
        setOriginalData([]);
        setOrderList([]);
      });
  }, [customer?.customer?.id, selectedCargoStatus]);

  const getDataForExcel = (list) => {
    api
      .post('flow/concierge-get-users', { metaTags: ['Zorlu Center'] })
      .then((response) => {
        if (response.data.status) setPersonelList(response.data.result || []);
        else setPersonelList([]);
      })
      .catch(() => {
        setPersonelList([]);
      });

    api
      .post('posts/get', {
        type: ['post-office', 'personal-post'],
        mallID: customer?.customer?.id,
        status: getEffectiveStatuses(selectedCargoStatus),
        limit: 20000,
      })
      .then((response) => {
        if (response.data.status) {
          const data = (response.data.result || []).filter(
            (item) =>
              item.dataJSON.direction === 'MallLogisticsToCustomer' ||
              item.dataJSON.direction === 'CustomerToMallLogistics'
          );
          exportToExcel(list, data);
        } else {
          toast.error('Veri bulunamadı.');
          setOriginalData([]);
          setOrderList([]);
        }
      })
      .catch(() => {
        toast.error('Veriler çekilemedi, bağlantınızı kontrol ediniz.');
        setOriginalData([]);
        setOrderList([]);
      });
  };

  useEffect(() => {
    getData();
  }, [getData]);

  const handleOpenAddPersonelModal = () => {
    setAddPersonelModalOpen(true);
    setIsModalEdit(false);
  };

  const handleOpenDeliveryModal = (id, object) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [...selected];
    let newSelectedItems = [...selectedItems];

    if (selectedIndex === -1) {
      newSelected.push(id);
      newSelectedItems.push(object);
    } else {
      newSelected.splice(selectedIndex, 1);
      const itemIndex = newSelectedItems.findIndex((item) => item.id === id);
      newSelectedItems.splice(itemIndex, 1);
    }

    setSelected(newSelected);
    setSelectedItems(newSelectedItems);
    setHandoverModal(true);
  };

  const handleCloseDeliveryModal = () => {
    setSelected([]);
    setSelectedItems([]);
    setHandoverModal(false);
  };

  const handleBack = () => {
    setSelectedOrder(null);
  };

  const handlePorterDone = () => {
    setHandoverModal(false);
    setSelected([]);
    setSelectedItems([]);
    setPorterTransactionIDs([]);
    getFilteredOrderList();
  };

  const cancelPorterTransactions = async () => {
    if (!porterTransactionIDs || porterTransactionIDs.length === 0) return;

    const transactionArray = porterTransactionIDs.map((transactionID) => ({
      transactionID,
      status: 2,
    }));

    const postArray = selectedItems
      .map((item) => item?.id)
      .filter(Boolean)
      .map((postID) => ({ postID, status: 5 }));

    try {
      await api.post('transactions/change-status', transactionArray);
      if (postArray.length > 0) {
        await api.post('posts/change-status', postArray);
      }
    } catch (error) {
      toast.error(error?.message || 'İptal sırasında bir hata oluştu.');
    } finally {
      setPorterTransactionIDs([]);
    }
  };

  const createPorterTransactions = async (porter) => {
    if (!porter?.id) {
      throw new Error('Seçili porter bulunamadı.');
    }

    if (!selectedItems || selectedItems.length === 0) {
      throw new Error('Seçili görev bulunamadı.');
    }

    const payload = selectedItems.map((task) => ({
      postID: task.id,
      porterID: porter.id,
      inventory: +task.orderInventory,
      changePostStatus: true,
      postStatus: 8,
      status: 8,
    }));

    const response = await api.post('transactions/create', payload);

    if (!response?.data?.status) {
      throw new Error(response?.data?.message || 'Transaction oluşturulamadı.');
    }

    return response.data.result;
  };

  const completeDeliver = async (code) => {
    setIsBackdropOpen(true);

    try {
      const selectedObjects = selected.map((item) => ({
        postID: item,
        status: 1,
      }));

      if (code !== confirmCode || selectedObjects.length === 0) {
        setIsBackdropOpen(false);
        toast.error('Doğrulama kodu hatalıdır. Lütfen tekrar deneyin.');
        return;
      }

      const response = await api.post('posts/change-status', selectedObjects);

      if (response.data.status) {
        setIsBackdropOpen(false);
        setHandoverModal(false);

        getFilteredOrderList();
        setSuccessModalOpen(true);

        Promise.all([
          createPDF(selectedItems, true),
          exportToExcel(selectedItems, orderList, true),
        ])
          .then(([pdfLink, excelLink]) => {
            let emailTo;
            for (const item of selectedItems) {
              const tower = item.dataJSON?.tower;
              if (tower && tower.length > 1 && emailsMap[tower]) {
                emailTo = emailsMap[tower];
                break;
              }
            }
            if (Array.isArray(emailTo)) {
              emailTo.forEach((mail) => {
                sendMail(selectedItems, pdfLink, excelLink, mail);
              });
            } else {
              sendMail(selectedItems, pdfLink, excelLink, emailTo);
            }
            if (emailTo) {
              sendMail(
                selectedItems,
                pdfLink,
                excelLink,
                'onur.tuzcu@alfred.com.tr'
              );
            }
          })
          .catch((err) => console.error('PDF/Excel veya mail hatası:', err));
      } else {
        setIsBackdropOpen(false);
        toast.error('Teslim işlemi tamamlanamadı.');
      }
    } catch (error) {
      setIsBackdropOpen(false);
      toast.error(error?.message || 'İşlem sırasında bir hata oluştu.');
    }
  };

  const handleDeliver = async (
    name,
    lastname,
    phone,
    note,
    deliveryType,
    porter
  ) => {
    const ts = moment();
    setDeliveryTimestamp(ts);

    const fullName = `${name} ${lastname}`;
    setRecieverNameLastname(fullName);

    let calculatedPackageCount = 0;
    for (let i = 0; i < selectedItems.length; i++) {
      calculatedPackageCount += Number(selectedItems[i].orderInventory);
    }
    setTotalPackageCount(calculatedPackageCount);

    if (deliveryType === 'porter') {
      try {
        setIsBackdropOpen(true);
        const transactionResults = await createPorterTransactions(porter);
        setPorterTransactionIDs(transactionResults.map((t) => t.id));
        setIsBackdropOpen(false);
        return true;
      } catch (error) {
        setIsBackdropOpen(false);
        toast.error(error?.message || 'Transaction oluşturulamadı.');
        return false;
      }
    }

    try {
      setIsBackdropOpen(true);

      const response = await api.post('handover/malllogistics/create', {
        postID: selected,
        message: `${selected?.length} adet gönderiyi (${calculatedPackageCount} paket) teslim alabilmeniz için {code} kodunu yetkiliye veriniz`,
        name,
        lastname,
        phone,
        note,
        sentHandoverMail: true,
      });

      setIsBackdropOpen(false);

      if (response.data.status) {
        setConfirmCode(response.data.result.code);
        return true;
      }

      toast.error(
        'Bir hata oluştu, lütfen pencereyi kapatıp gönderiyi yeniden seçerek işlemi tekrar ediniz.'
      );
      return false;
    } catch (error) {
      setIsBackdropOpen(false);
      console.log(error);
      toast.error('İşlem sırasında bir hata oluştu.');
      return false;
    }
  };

  return (
    <>
      <Helmet>
        <title> Muhaberat Çıkış | Mall Logistics Panel </title>
      </Helmet>

      <Stack style={{ paddingInline: '25px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Muhaberat Çıkış
          </Typography>

          {['store:manageroperations', 'store:operations'].includes(
            tokenService.getUser()?.accountCategory +
              ':' +
              tokenService
                .getUser()
                ?.frontAuth?.map((x) => x)
                .join('')
          ) &&
            hasMuhaberatOffice && (
              <Button
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
                onClick={() => setOpenCreateModal(true)}
              >
                İş Emri Oluştur
              </Button>
            )}

          <Stack
            direction={isMobile ? 'column' : 'row'}
            alignItems="end"
            justifyContent="flex-start"
            paddingY={2}
            paddingX={1}
            spacing={2}
          >
            {showAddPersonelModal && hasMuhaberatOffice ? (
              <>
                {parsedUser.type !== 'user' && (
                  <>
                    <Button
                      sx={{
                        marginInline: '8px',
                        fontSize: 14,
                        fontFamily: 'Inter',
                        fontWeight: 400,
                        letterSpacing: 0.4,
                        height: 40,
                        borderRadius: '5px',
                        padding: '8px 16px 8px 16px',
                        gap: '6px',
                      }}
                      variant="contained"
                      color="primary"
                      component={Link}
                      to="/dashboard/muhaberat-output-users"
                    >
                      KULE ÇALIŞANI LİSTESİ
                    </Button>

                    <AddEntityButton
                      label="Kule Çalışanı Ekle"
                      onClick={handleOpenAddPersonelModal}
                    />
                  </>
                )}
              </>
            ) : null}

            {hasMuhaberatOffice && (
              <ExportToExcelButton
                setShowPopUpError={setShowPopUpError}
                showPopUpError={showPopUpError}
                onClick={() => exportToExcel(orderList)}
                sx={{ marginLeft: '7px' }}
              />
            )}
          </Stack>
        </Stack>

        {isMallLoading ? (
          <Card sx={{ p: 4 }}>
            <Typography>AVM bilgileri yükleniyor...</Typography>
          </Card>
        ) : !hasMuhaberatOffice ? (
          <Card sx={{ p: 4, borderRadius: 2 }}>
            <Stack spacing={2}>
              <Typography variant="h6">
                Seçili Avm'de Muhaberat bulunmamaktadır
              </Typography>

              {selectedMall?.title && (
                <Typography variant="body2" color="text.secondary">
                  Seçili AVM: {selectedMall.title}
                </Typography>
              )}
            </Stack>
          </Card>
        ) : (
          <>
            <Stack
              direction="row"
              justifyContent={isMobile ? 'space-between' : 'end'}
              mb={5}
            >
              {isMobile ? (
                <FilterViewButton variant="contained" onClick={handleModal} />
              ) : null}
            </Stack>

            <Card>
              <CustomFilter
                modalType="drawer"
                filterModal={filterModal}
                handleCloseModal={handleCloseModal}
              >
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="flex-start"
                  spacing={2}
                  padding={2}
                  mb={2}
                >
                  <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                    <TextField
                      label="Barkod"
                      inputRef={firstInputRef}
                      variant="outlined"
                      value={barcode}
                      onChange={(e) => setBarcode(e.target.value.trim())}
                      error={barcode.length > 0 && barcode.length < 5}
                      helperText={
                        barcode.length > 0 && barcode.length < 5
                          ? 'En az 5 karakter giriniz'
                          : ''
                      }
                      inputProps={{ minLength: 5 }}
                      sx={{ flex: 1 }}
                    />
                  </FormControl>

                  <FormControl
                    sx={{ flex: 1, minWidth: '100%', maxWidth: '100%' }}
                  >
                    <Select
                      multiple
                      displayEmpty
                      value={selectedBranches}
                      onChange={handleChangeFilterBranch}
                      input={<OutlinedInput />}
                      renderValue={(selectedValue) => {
                        if (!selectedValue || selectedValue.length === 0) {
                          return <em>Firma</em>;
                        }

                        return selectedValue
                          .map(
                            (id) =>
                              branchTitles.find(
                                (branch) => branch.branchID === id
                              )?.branchTitle || id
                          )
                          .join(', ');
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      {branchTitles.map((x) => (
                        <MenuItem key={x.branchID} value={`${x.branchID}`}>
                          {x.branchTitle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                    <TextField
                      label="Kargo Firması"
                      variant="outlined"
                      value={cargo}
                      onChange={(e) => setCargo(e.target.value)}
                      sx={{ flex: 1 }}
                    />
                  </FormControl>

                  <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                    <TextField
                      label="Kule"
                      variant="outlined"
                      value={tower}
                      onChange={(e) => setTower(e.target.value)}
                      sx={{ flex: 1 }}
                    />
                  </FormControl>

                  <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                    <TextField
                      label="Daire"
                      variant="outlined"
                      value={office}
                      onChange={(e) => setOffice(e.target.value)}
                      sx={{ flex: 1 }}
                    />
                  </FormControl>

                  <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                    <TextField
                      label="Teslim Alan kişi"
                      variant="outlined"
                      value={deliveredName}
                      onChange={(e) => setDeliveredName(e.target.value)}
                      sx={{ flex: 1 }}
                    />
                  </FormControl>
                </Stack>

                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="flex-start"
                  spacing={2}
                  paddingX={2}
                  mb={2}
                >
                  <Stack direction="row" spacing={1}>
                    <FormControl sx={{ flex: 1, minWidth: '49%' }}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          label="Başlangıç Tarihi"
                          value={startDate}
                          onChange={(newValue) => setStartDate(newValue)}
                          sx={{ flex: 1 }}
                        />
                      </LocalizationProvider>
                    </FormControl>

                    <FormControl sx={{ flex: 1, minWidth: '49%' }}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <DatePicker
                          label="Bitiş Tarihi"
                          value={endDate}
                          onChange={(newValue) => setEndDate(newValue)}
                          sx={{ flex: 1 }}
                        />
                      </LocalizationProvider>
                    </FormControl>
                  </Stack>

                  <FormControl sx={{ flex: 1, minWidth: '100%' }}>
                    <Select
                      multiple
                      displayEmpty
                      value={selectedCargoStatus}
                      onChange={handleChange}
                      input={<OutlinedInput />}
                      renderValue={(selectedValue) => {
                        if (selectedValue.length === 0) {
                          return <em>Kargo Durumu</em>;
                        }
                        return selectedValue.map((x) => x?.label).join(', ');
                      }}
                      MenuProps={MenuProps}
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      {StatusList.map((x) => (
                        <MenuItem key={x.id} value={x}>
                          {x.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Stack>

                <Stack
                  direction="column"
                  justifyContent="flex-start"
                  spacing={2}
                  paddingX={2}
                  mb={2}
                >
                  <Stack direction="row" gap={2}>
                    <FormControl sx={{ flex: 1, minWidth: '75%' }}>
                      <TextField
                        label="Kişi"
                        variant="outlined"
                        value={filterName}
                        onChange={(e) => setFilterName(e.target.value)}
                        sx={{ flex: 1 }}
                      />
                    </FormControl>

                    <FormControl sx={{ flex: 1, minWidth: '25%' }}>
                      <FormControlLabel
                        sx={{ flex: 1 }}
                        control={
                          <Checkbox
                            checked={customerNameLike}
                            onChange={handleChangeCustomerNameLike}
                          />
                        }
                        label="İçeren"
                      />
                    </FormControl>
                  </Stack>
                </Stack>

                <Divider sx={{ width: '100%', mb: 2 }} />

                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  mb={2}
                  paddingX={2}
                >
                  <Stack direction="row" spacing={2}>
                    <ClearButton onClick={clearFilters} />
                    <FilterButton onClick={getFilteredOrderList} />
                  </Stack>
                </Stack>
              </CustomFilter>

              <DynamicTable
                data={orderList}
                headers={TABLE_HEAD}
                initialOrder="createdDateTime"
                initalOrderDirection="desc"
                isOrdered={false}
                handleCheckboxChange={handleCheckboxChange}
                selected={selected}
                isMobile={isMobile}
                handleModal={handleModal}
                handleCloseModal={handleCloseModal}
                resetPage={resetPage}
              >
                {parsedUser.type !== 'user' && (
                  <Stack direction="row" spacing={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={selectAll}
                    >
                      Hepsini Seç
                    </Button>

                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        setSelected([]);
                        setSelectedItems([]);
                      }}
                    >
                      Hepsini Kaldır
                    </Button>
                  </Stack>
                )}
              </DynamicTable>
            </Card>
          </>
        )}
      </Stack>

      {addPersonelModalOpen && hasMuhaberatOffice && (
        <AddEditPersonelModal
          open={addPersonelModalOpen}
          onClose={() => setAddPersonelModalOpen(false)}
          isEdit={isModalEdit}
        />
      )}

      {openCreateModal && hasMuhaberatOffice && (
        <CreateWorkOrderModal
          openCreateModal={openCreateModal}
          onCreateModal={() => setOpenCreateModal(false)}
          customer={customer}
          locations={locations}
        />
      )}

      {handoverModal && hasMuhaberatOffice && (
        <DeliveryModal
          open={handoverModal}
          count={selectedItems?.length}
          onClose={handleCloseDeliveryModal}
          onBack={handleBack}
          onDeliver={handleDeliver}
          onComplete={completeDeliver}
          onPorterDone={handlePorterDone}
          onCancelPorter={cancelPorterTransactions}
          selectedItems={selectedItems}
          showPorterOption={canProceedWithPorter}
          muhaberatStaticQR={muhaberatStaticQR}
          onAddPersonel={() => {
            setSelected([]);
            setSelectedItems([]);
            setHandoverModal(false);
            handleOpenAddPersonelModal();
          }}
          isLoading={isBackdropOpen}
          packageCount={totalPackageCount}
        />
      )}

      {selected?.length > 0 && hasMuhaberatOffice && (
        <Box className="bottom-center-container">
          <Button
            variant="contained"
            color="primary"
            className="bottom-center-button"
            onClick={() => setHandoverModal(true)}
          >
            ({selected?.length}) Teslim Et
          </Button>
        </Box>
      )}

      {editModalOpen && hasMuhaberatOffice && (
        <EditMuhaberatOutputPost
          post={selectedPost}
          onClose={handleCloseEditModal}
        />
      )}

      <Modal open={qrModalOpen} onClose={() => setQrModalOpen(false)}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="h6">Muhaberat QR</Typography>

          {muhaberatStaticQR ? (
            <Box
              sx={{
                width: 260,
                height: 260,
                border: '1px solid #E0E0E0',
                borderRadius: 2,
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fff',
                p: 1,
              }}
            >
              <img
                src={muhaberatStaticQR}
                alt="Muhaberat QR"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </Box>
          ) : (
            <Typography color="error">Muhaberat QR bulunamadı.</Typography>
          )}

          <Button
            variant="contained"
            sx={{ minWidth: 180 }}
            onClick={() => setQrModalOpen(false)}
          >
            Kapat
          </Button>
        </Box>
      </Modal>

      <Modal
        open={isSuccessModalOpen}
        onClose={() => {
          setSuccessModalOpen(false);
          window.location.reload();
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            width: 700,
            height: 350,
            bgcolor: 'background.paper',
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <CheckCircleIcon sx={{ color: 'green', fontSize: 64 }} />

          <Typography variant="h6">
            {selected?.length} adet gönderi başarıyla teslim edildi.
          </Typography>

          <Typography>
            Aşağıdaki seçenekler ile seçiminizi, Excel veya PDF formatında
            indirebilirsiniz.
          </Typography>

          <Tooltip title="Dosya indirme hakkında bilgi için tıklayın">
            <IconButton
              size="small"
              sx={{
                color: 'gray',
                marginLeft: '8px',
                animation: 'pulse 2s infinite',
                '@keyframes pulse': {
                  '0%': { transform: 'scale(1)', color: 'gray' },
                  '50%': { transform: 'scale(1.1)', color: '#088AB2' },
                  '100%': { transform: 'scale(1)', color: 'gray' },
                },
              }}
              onClick={handleOpen}
            >
              <HelpOutlineIcon />
            </IconButton>
          </Tooltip>

          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 800,
                bgcolor: 'background.paper',
                borderRadius: '10px',
                boxShadow: 24,
                p: 4,
                justifyContent: 'flex-end',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <h3 id="modal-title">Dosya İndirme Uyarısı</h3>
              <img
                src={require('../../src/assets/images/popUpError.png')}
                alt="Pop-up Error"
                style={{
                  display: 'block',
                  margin: '20px auto',
                  maxWidth: '100%',
                  height: 'auto',
                }}
              />
              <p id="modal-description">
                Eğer tarayıcınızda görseldeki işareti görüyorsanız, gösterilen
                ikona tıklayarak tarayıcınızdan, bu sayfa için{' '}
                <b>"Pop-up'lar ve yönlendirmeler"</b> seçeneğine izin vermeniz
                gerekmektedir.
              </p>
              <Button onClick={handleClose} variant="contained" color="primary">
                Tamam
              </Button>
            </Box>
          </Modal>

          <Button
            sx={{ width: 500 }}
            variant="contained"
            color="info"
            onClick={() => createPDF(selectedItems)}
          >
            PDF'e Aktar
          </Button>

          <Button
            sx={{ width: 500 }}
            variant="contained"
            color="info"
            onClick={() => getDataForExcel(selectedItems)}
            disabled={!isOnline}
          >
            {isOnline
              ? 'Excele Aktar'
              : "Excel'e aktar (İnternet bağlantısı gerekmektedir.)"}
          </Button>

          <Button
            sx={{ width: 500 }}
            onClick={() => {
              setSuccessModalOpen(false);
              window.location.reload();
            }}
          >
            Tamam
          </Button>
        </Box>
      </Modal>
    </>
  );
}
